import { environment } from '../../environments/environment';

export function debugLog(...args: unknown[]): void {
  if (!environment.production) {
    console.debug(...args);
  }
}
